import RpcClass from "../../../../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.marketPlace.services.roleSupplierCheckbox.SupplierRoleCheckboxChangeService';

import LocalDate from "../../../../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../../../../server/LocalTime.js";



class SupplierRoleCheckboxChangeService extends RpcClass{

    /**
     *  @class SupplierRoleCheckboxChangeService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/marketPlace/services/roleSupplierCheckbox/SupplierRoleCheckboxChangeService.SupplierRoleCheckboxChangeService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param supplierId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     blockContactorWithInvitationFromList(supplierId) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/role-supplier-checkbox/supplier-role-checkbox-change-service/block-contactor-with-invitation-from-list', [supplierId]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     blockSendingMessages(entityId, inquiryType) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/role-supplier-checkbox/supplier-role-checkbox-change-service/block-sending-messages', [entityId, inquiryType]);
    }
    /** 
     * @async
     * @param supplierId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfCanBeSend(supplierId) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/role-supplier-checkbox/supplier-role-checkbox-change-service/check-if-can-be-send', [supplierId]);
    }
    /** 
     * @async
     * @param supplierId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     giveSupplierRoleToContractor(supplierId) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/role-supplier-checkbox/supplier-role-checkbox-change-service/give-supplier-role-to-contractor', [supplierId]);
    }
    /** 
     * @async
     * @param supplierId {string} 
     * @param openFromGrid {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     removeContactorWithoutInvitationFromList(supplierId, openFromGrid) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/role-supplier-checkbox/supplier-role-checkbox-change-service/remove-contactor-without-invitation-from-list', [supplierId, openFromGrid]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.marketPlace.services.roleSupplierCheckbox.SupplierRoleCheckboxChangeService';
metadata.__type_short__ = 'SupplierRoleCheckboxChangeService';
SupplierRoleCheckboxChangeService.prototype.__metadata__ = metadata;

SupplierRoleCheckboxChangeService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/marketPlace/services/roleSupplierCheckbox/SupplierRoleCheckboxChangeService */
export default SupplierRoleCheckboxChangeService

export { SupplierRoleCheckboxChangeService }
